import { withRpcReadAccess } from 'src/app/AppAuth/ReadAccess'
import React, { useMemo } from 'react'
import {
  UserRecord,
  UserState,
} from '@trustero/trustero-api-web/lib/account/account_pb'
import { Owner as OwnerEnum } from 'src/Utils/globalEnums'
import { useUsers } from 'src/components/async/Users/useUsers'
import { SelectDropdown } from 'src/components/Reusable/SelectDropdown/SelectDropdown'
import { SelectItem } from 'src/components/Reusable/SelectDropdown/SelectDropdown.constants'
import { UserSelectLabel } from 'src/components/Reusable/UserSelectLabel'

type ShowPageOwnerDropdownProps = {
  ownerEmail: string
  isDisabled?: boolean
  hideLabel?: boolean
  onSave: (email: string) => Promise<void>
}

const ShowPageOwnerDropdownContent = ({
  ownerEmail,
  isDisabled = false,
  hideLabel = false,
  onSave,
}: ShowPageOwnerDropdownProps): JSX.Element => {
  const response = useUsers()

  const unassignedUser = useMemo<SelectItem>(
    () => ({
      name: (
        <UserSelectLabel
          email={OwnerEnum.UNASSIGNED}
          name={OwnerEnum.UNASSIGNED}
        />
      ),
      value: OwnerEnum.UNASSIGNED,
    }),
    [],
  )

  const activeUsers = useMemo<SelectItem[]>(() => {
    const users: SelectItem[] = [unassignedUser]
    if (response.data) {
      users.push(
        ...response.data
          .getUsersList()
          .filter((u: UserRecord) => u.getState() === UserState.USER_ACTIVE)
          .map((u: UserRecord) => ({
            name: (
              <UserSelectLabel
                email={u.getEmail()}
                name={u.getName() || u.getEmail()}
              />
            ),
            value: u.getEmail(),
          })),
      )
    }
    return users
  }, [response.data, unassignedUser])

  const currentOwner =
    activeUsers.find((u) => u.value === ownerEmail) || unassignedUser

  const onSelectCb = async (selected: SelectItem[]) => {
    const email = selected[0]?.value as string
    await onSave(email)
  }

  return (
    <SelectDropdown
      items={activeUsers}
      defaultValues={[currentOwner]}
      label="Owner"
      onSelectCb={onSelectCb}
      isDisabled={isDisabled}
      hideLabel={hideLabel}
      isSearchable
      hideError
    />
  )
}

export const ShowPageOwnerDropdown = withRpcReadAccess(
  ShowPageOwnerDropdownContent,
  '/account.User/GetUsersInAccount',
)
